/**
 * Нормализация transfer/transferType action (контракт со Swing).
 * Пустой `<transfer/>` в метаданных при заданном transferType трактуется как `0`.
 */

export function extractActionTextValue(val: unknown): unknown {
  return (val as { _text?: unknown })?._text ?? val
}

/** Пустой `<image/>` в action → undefined (xml-js часто отдаёт `{}`). */
export function normalizeActionImageName(raw: unknown): string | undefined {
  if (raw == null) return undefined
  const extracted = extractActionTextValue(raw)
  if (extracted == null || extracted === '') return undefined
  if (typeof extracted === 'object') return undefined
  const name = String(extracted).trim()
  if (!name || name === '[object Object]') return undefined
  return name
}

/** Тело onClick/confirm/event из action-узла формы (_text или plain string). */
export function extractActionScriptText(val: unknown): string {
  const raw = extractActionTextValue(val)
  return typeof raw === 'string' ? raw.trim() : ''
}

/** Тип transfer «не задан» — нет платформенного doAction по transferType. */
export function isUnsetActionTransferType(transferType: unknown): boolean {
  const n = String(extractActionTextValue(transferType) ?? '').trim().toLowerCase()
  if (n === '') return true
  return n === 'не_задано'
}

/**
 * Пустой transfer при заданном transferType (кроме «Не_задано») → `'0'`, как в Swing и GlobalProvider onSelectionChanged.
 */
export function normalizeActionTransferValue(
  transfer: unknown,
  transferType: unknown,
): string {
  const rawTransfer = extractActionTextValue(transfer)
  const transferStr =
    rawTransfer === undefined || rawTransfer === null ? '' : String(rawTransfer).trim()

  if (transferStr !== '') {
    return transferStr
  }

  if (!isUnsetActionTransferType(transferType)) {
    return '0'
  }

  return transferStr
}

/** Есть ли пара transfer + transferType для платформенного конвейера (после нормализации transfer). */
export function hasNormalizedActionTransfer(
  transfer: unknown,
  transferType: unknown,
): boolean {
  const typeRaw = extractActionTextValue(transferType)
  if (typeRaw === undefined || typeRaw === null || String(typeRaw).trim() === '') {
    return false
  }
  const normalizedTransfer = normalizeActionTransferValue(transfer, transferType)
  return normalizedTransfer !== ''
}
